export class SubCategoryModel{
    id:number;
    description:string;
    isActive:boolean
}


export class SubCategoryModelGroup{
    rowId:number;
    subCategoryModel:Array<SubCategoryModel>
}